interface Window {
  _env_?: {
    VITE_API_URL?: string;
    [key: string]: unknown;
  };
}

export const API_URL =
  // If window._env_ exists (i.e. in Docker/prod) use it…
  (window as Window)._env_?.VITE_API_URL ??
  // …otherwise fall back to Vite’s compile-time value:
  import.meta.env.VITE_API_URL;
